import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  FeatureUserConfiguration,
  FEATURE_USER_CONFIGURATION,
} from './feature-user-configuration';
import { WINDOW } from './services/user.service';
import { SignInOrUpComponent } from './sign-in-or-up/sign-in-or-up.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatListModule,
    MatSnackBarModule,
    TranslateModule,
  ],
  declarations: [UserInfoComponent, SignInOrUpComponent],
  exports: [UserInfoComponent, SignInOrUpComponent],
})
export class CommunityUserFeatureUserModule {
  static forRoot(
    configuration: FeatureUserConfiguration
  ): ModuleWithProviders<CommunityUserFeatureUserModule> {
    return {
      ngModule: CommunityUserFeatureUserModule,
      providers: [
        {
          provide: FEATURE_USER_CONFIGURATION,
          useValue: configuration,
        },
        {
          provide: WINDOW,
          useValue: window,
        },
      ],
    };
  }
}
